import React from "react";
import AirportContent from "../components/airports/airport-content";

const Airports = () => {
  return <AirportContent />;
};

export default Airports;
